import React from "react";
import { Card, Row, Col, Button, Badge } from "react-bootstrap";
import {
  IconPlus,
  IconBuilding,
  IconBrandWhatsapp,
  IconUser,
  IconMessage,
  IconUsers,
  IconAddressBook,
} from "@tabler/icons-react";
import PlanServices from "../../../services/PlanServices";

// Mapeamento de ícones para addons
const ADDON_ICONS = {
  addon_subaccount: IconBuilding,
  addon_whatsapp_instance: IconBrandWhatsapp,
  addon_user: IconUser,
  addon_whatsapp_messages: IconMessage,
  addon_clients: IconUsers,
  addon_contacts: IconAddressBook,
};

const AddonsSection = ({ addons, onSelectAddon }) => {
  if (!addons || addons.length === 0) {
    return null;
  }

  const getAddonIcon = (addonId) => {
    const IconComponent = ADDON_ICONS[addonId];
    return IconComponent ? <IconComponent size={24} /> : <IconPlus size={24} />;
  };

  return (
    <Card className="shadow-sm">
      <Card.Header className="bg-light">
        <div className="d-flex align-items-center">
          <IconPlus size={20} className="text-primary me-2" />
          <h5 className="mb-0">Recursos Adicionais Disponíveis</h5>
        </div>
        <small className="text-muted">
          Expanda as capacidades do seu plano Business com recursos extras
        </small>
      </Card.Header>
      <Card.Body>
        <Row>
          {addons.map((addon) => (
            <Col xs={12} sm={6} lg={4} key={addon.id} className="mb-3">
              <Card className="h-100 border hover-shadow" style={{ transition: "box-shadow 0.2s" }}>
                <Card.Body className="d-flex flex-column">
                  <div className="d-flex align-items-start mb-3">
                    <div
                      className="d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10px",
                        backgroundColor: "rgba(126, 58, 242, 0.1)",
                        flexShrink: 0
                      }}
                    >
                      <span className="text-primary">
                        {getAddonIcon(addon.id)}
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mb-1">{addon.name}</h6>
                      <small className="text-muted">por {addon.unit}</small>
                    </div>
                  </div>

                  <div className="mt-auto">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span className="text-primary fs-4 fw-bold">
                        {PlanServices.formatCurrency(addon.price)}
                      </span>
                      <Badge bg="secondary" className="px-2">
                        /mês
                      </Badge>
                    </div>

                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="w-100 d-flex align-items-center justify-content-center"
                      onClick={() => onSelectAddon(addon)}
                    >
                      <IconPlus size={16} className="me-1" />
                      Contratar
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default AddonsSection;
